import { IPayment } from "src/domain/entities"
import { paymentListApi } from "../../api/payment/paymentListApi"

type PayloadShape = Parameters<typeof paymentListApi>[0]

export async function paymentListService(payload: PayloadShape, token?: null | string) {
	const payment = await paymentListApi(payload, token)
	return payment as NonNullable<IPayment[]>
}
